var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:([_vm.imageSize])},[_c('v-img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":"/res/icon/iot/camera.png"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }